import './trending-top-card.scss'

import React from 'react'

import Card from '@/components/card/card'

const config = {
  className: 'trending-top-card',
  minicard: false,
  hasNoImage: false,
  hasUnderline: true,
  hasNoLocationDisplay: true,
  isSearch: false,
  isCarousel: false,
}

export const TrendingTopCard = ({ item, ...restProps }) => (
  <Card item={item} {...restProps} {...config} />
)
